module.exports = __webpack_public_path__ + "img/wolf.2de6bdd5.png";